"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats and sanitizes a postal code to only show valid characters.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#normalizepostalcodepostal_code}
 */
function normalizePostalCode(postal_code) {
    //strip non-alphanumerics (CA spaces are ignored, US hyphens will be added if necessary)
    var oldValue = postal_code.replace(/[^a-zA-Z0-9]+/g, '');
    var newValue = '';
    if ('0123456789'.indexOf(oldValue.charAt(0), 0) != -1) {
        // first character is number, US postal code
        for (var i = 0; i < oldValue.length; i++) {
            var x = oldValue.charAt(i);
            if (newValue.length < 10) {
                if ('0123456789'.indexOf(x, 0) != -1) {
                    // if char is number
                    if (newValue.length === 5) {
                        // add hyphen before sixth number
                        newValue += '-';
                    }
                    newValue += x;
                }
            }
        }
    }
    else {
        // first character is letter, Canadian postal code
        for (var i = 0; i < oldValue.length; i++) {
            var x = oldValue.charAt(i);
            if (newValue.length < 6) {
                if (newValue.length % 2) {
                    // should be number
                    if (/\d/.test(x)) {
                        newValue += x;
                    }
                }
                else {
                    if (/[A-Za-z]/.test(x)) {
                        newValue += x;
                    }
                }
            }
        }
    }
    return newValue;
}
exports.default = normalizePostalCode;
